// Pure helpers used across the Bills page + its sub-components.
// Kept in a plain .js so they can be imported without JSX overhead.

export const FILTERS = [
  { key: "all", label: "All" },
  { key: "overdue", label: "Overdue" },
  { key: "unpaid", label: "Unpaid" },
  // Chip labels below mirror the status-dropdown values ("Pending" / "Paid")
  // so users don't have to translate between "Not cleared" (filter) and
  // "Pending" (status). The `key` stays technical for URL stability.
  { key: "not-cleared", label: "Pending" },
  { key: "cleared", label: "Paid" },
  { key: "autopay", label: "Autopay" },
  { key: "recurring", label: "Recurring" },
];

export function monthLabel(d) {
  return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export function shortDate(iso) {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

// Compute current + next pay-period ranges (as [start, end] Date objects) from /forecast/pay-periods
export function computePayPeriodRanges(payPeriods, today) {
  if (!payPeriods || payPeriods.length === 0) return { current: null, next: null };
  const sorted = [...payPeriods].sort((a, b) => a.period_end.localeCompare(b.period_end));
  const upcoming = sorted.filter((p) => new Date(p.period_end + "T00:00:00") >= today);
  const current = upcoming[0] ? {
    start: new Date(upcoming[0].period_start + "T00:00:00"),
    end: new Date(upcoming[0].period_end + "T00:00:00"),
  } : null;
  const next = upcoming[1] ? {
    start: new Date(upcoming[1].period_start + "T00:00:00"),
    end: new Date(upcoming[1].period_end + "T00:00:00"),
  } : null;
  return { current, next };
}

export function payPeriodClassFor(bill, ranges) {
  const due = new Date(bill.due_date + "T00:00:00");
  if (ranges.current && due >= ranges.current.start && due <= ranges.current.end) {
    return "bg-[#FFFBEA] hover:bg-[#FFF6D0]"; // current pay period → soft yellow
  }
  if (ranges.next && due >= ranges.next.start && due <= ranges.next.end) {
    return "bg-[#EEF4FA] hover:bg-[#DEEBF6]"; // next pay period → soft blue
  }
  return "bg-[#F9F8F6] hover:bg-[#F5F3EF]";
}
